import { createReducer } from '@reduxjs/toolkit';
import { type TopProps } from '../types/WidgetProps';
import { updateTopProps } from '../actions/payment/updateTopProps';

// @ts-expect-error
export const initState: TopProps = {};

export const topPropsReducer = createReducer(initState, (builder) => {
  builder.addCase(updateTopProps, (_state, action) => {
    return { ...action.payload };
  });
});
